<template>
	<div class="modal modal--resource modal-resource">
		<div class="modal__loading" v-if="loading">
			<loading-spinner />
		</div>
		<div class="modal-resource__form">
			<form-resource :resource="resource" />
		</div>
		<div class="modal-resource__stats">
			<dl>
				<dt>Date Created</dt>
				<dd>{{ resource.dateCreated | date('PPp') }}</dd>
				<dt>Created By</dt>
				<dd>{{ resource.createdByName }}</dd>
				<dt>Date Modified</dt>
				<dd>{{ resource.dateModified | date('PPp') }}</dd>
				<dt>Modified By</dt>
				<dd>{{ resource.modifiedByName }}</dd>
			</dl>
		</div>
	</div>
</template>

<script>
import FormResource from '@/components/FormResource'
import LoadingSpinner from '@/components/LoadingSpinner'

export default {
	name: 'ModalResource',
	components: {
		FormResource,
		LoadingSpinner,
	},
	props: {
		listener: Function,
	},
	data: () => ({
		loading: false,
	}),
	async mounted() {
		this.loading = true
		if (this.$route.params.resourceId) {
			await this.$store.dispatch('resource/get', this.$route.params.resourceId)
		}
		this.loading = false
	},
	destroyed() {
		this.$store.dispatch('resource/unset')
	},
	computed: {
		resource() {
			return this.$store.getters['resource/resource']
		},
	},
	methods: {
	},
}
</script>

<style scoped lang="scss">
.modal-resource {
	display: grid;
	grid-template-columns: 2fr minmax(10rem, 1fr);
	min-width: 70vw;
	width: 100%;

	@include modules.media-query-max-width('desktop-xs') {
		grid-template-columns: 1fr;
	}

	dl {
		@include modules.fontSize(14px);
		@include modules.gutter('grid-row-gap', 0.5);
		display: grid;
		grid-column-gap: 0;
		grid-template-columns: 1fr auto;
	}

	dd {
		margin: 0;
		text-align: right;
		padding: 0.5rem;

		&:nth-of-type(odd) {
			background-color: modules.color_('background', 'light');
		}
	}

	dt {
		font-weight: 500;
		padding: 0.5rem;
		text-transform: uppercase;

		&:nth-of-type(odd) {
			background-color: modules.color_('background', 'light');
		}
	}
}
</style>
